import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Subway,AirportShuttle,SupervisedUserCircle,Edit,Delete,SwapHoriz,Done,PhoneAndroid} from '@material-ui/icons';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Switch
} from "@material-ui/core";


import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import {TransportService,AdminService,FinanceService} from "./../../utils/web_config_2";

import { useSnackbar } from 'notistack';

import UserInfo from './login_info';

import axios from 'axios';


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow:1,
        [theme.breakpoints.up('sm')]:{
          marginLeft:250,
        }
      },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
}));

 function Devices() {
  const classes = useStyles1();

  
  const [agentData, setagentData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [deviceMessage,setDeviceMessage]=useState("Loading...");

  const [load,setLoad]=useState(false);

  /// commission table




  const columns = [
    {
        name: "id",
        label: "id",
        options: {
         display:false,
         filter: true,
         sort: true,
        }
       },
    {
     name: "device_type",
     label: "Device Type",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
        name: "serial_number",
        label:"Serial Number",
        options: {
         filter: true,
         sort: true,
        }
       }
       ,{
     name: "agent_outlet_id",
     label:"Outlet",
     options: {
      filter: true,
      sort: false,
     }
    },
   
       {
        name: "status",
        label: <Translate id="agent_commission.table_commission.status" />,
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => {
             if(value=="DISABLED"){
                return (
                    <Chip
                    color="secondary"
                    label={value}
                    onDelete={()=>{}}
                    deleteIcon={<Block />}
                  ></Chip>
                      
                  );
             }else{
                return (
                    <Chip
                    color="primary"
                    label={value}
                    onDelete={()=>{}}
                    deleteIcon={<Done />}
                  ></Chip>
                      
                  );
             }
         
        }
        }
       }
   ];
     
   const options = {textLabels: {
    body: {
      noMatch: deviceMessage
    },
  },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:"single",
     rowsPerPage: 10,
     selectableRows: "single",
     elevation:0,
     customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
         var id=displayData[selectedRows.data[0]['index']]['data'][0];
         var index=devices.findIndex((o)=>o.id==id);
         var obj=devices.find((o)=>o.id==id);
         return  <Box display="flex">
         <FormControlLabel
         control={
           <Switch
             checked={obj.status=="ENABLED"?true:false}
             onChange={(e)=>{
                console.log(e.target.checked);
                if(e.target.checked==true){
                    activate_device(id);
                }else{
                    deactivate_device(id);
                }
             }}
             name="status"
             color="primary"
             disabled={load}
           />
         }
         label={obj.status=="ENABLED"?"Deactivate":"Reactivate"}
       />
         </Box>
     }
     
   };



   useEffect(()=>{

    console.log("code");
    console.log(new UserInfo().CODE);
    var data = {};
  const data1 = localStorage.getItem("nx_ag");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setagentData(data);
  axios.defaults.baseURL = new FinanceService().BASE_URL;
  get_devices(data.token);
   },[]);


// fetch devices

 const [messageLoad,setMessageLoad]=useState(false);
 const [devices,setDevices]=useState([]);
 const get_devices=(token)=>{
    setMessageLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
   const devicesInstance = axios.create(new FinanceService().setHeaders(token));
   devicesInstance.get('/api/v1/getAgentDevices/'+new UserInfo().CODE
   ).then(res=>{
    setMessageLoad(false);
       if(res.data.data==0){
        setDeviceMessage("No devices available");
       }
       setDevices(res.data.data);
       console.log("devices");
       console.log(res.data);
   }).catch(err=>{
    setMessageLoad(false);
     console.log(err);
     enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
   })
 }

 // activate device

 const activate_device=(id)=>{
    setLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const activateInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    activateInstance.put('/api/v1/enableAgentDevice/'+id
   ).then(res=>{
       var obj=devices.find((d)=>d.id==id);
       var index=devices.findIndex((d)=>d.id==id);
       obj['status']="ENABLED";
       var objs=devices;
       objs[index]=obj;

       setDevices(objs);
       

    setLoad(false);
    enqueueSnackbar("Device activated successful!",
        { 
          variant: 'success'
        });

   }).catch(err=>{
    setLoad(false);
     console.log(err);
     enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
   })
 }

//  deactivate device 
  
const deactivate_device=(id)=>{
    setLoad(true);
    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const activateInstance = axios.create(new FinanceService().setHeaders(agentData.token));
    activateInstance.put('/api/v1/disableAgentDevice/'+id
   ).then(res=>{
       var obj=devices.find((d)=>d.id==id);
       var index=devices.findIndex((d)=>d.id==id);
       obj['status']="DISABLED";
       var objs=devices;
       objs[index]=obj;

       setDevices(objs);
       

    setLoad(false);
    enqueueSnackbar("Device deactivated successful!",
        { 
          variant: 'success'
        });

   }).catch(err=>{
    setLoad(false);
     console.log(err);
     enqueueSnackbar(err.status,
        { 
          variant: 'error'
      });
   })
 }

  return (

    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <PhoneAndroid fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b><Translate id="agent_devices.title"/></b></Typography>

 </Box>
 
 
     </Box>

 {/* vehicles table  */}

 <Box mt={2}>
 {messageLoad&&<LinearProgress color="primary" />}
 <MUIDataTable
  title={<Translate id="agent_devices.device_list"/>}
  data={devices}
  columns={columns}
  options={options}
/>
 </Box> 

    </div>
  );
}
export default withLocalize(Devices);